import { observable, action } from 'mobx'
import { message } from 'hljd'
import Api from '@api/xiu_yan/cashierApi'
import homeApi from '@api/xiu_yan/homeApi'
import checkApi from '@api/xiu_yan/registerLiteAppApi'
import { toTimestamp, now } from '@hlj/hlj-utils'

class Store {
  @action
  already = async () => {
    const { server_end } = this
    let end_time = toTimestamp(server_end)
    let now_time = toTimestamp(now())
    if (server_end && end_time > now_time) {
      message.success('开通成功！')
      setTimeout(() => {
        window.location.href = '#/localMerchant/liteApp/authorize'
      }, 3000)
    } else {
      let { data, success } = await Api.pay({ agent: 'wx_native' })
      if (success) {
        if (data.pay_success) {
          message.success('开通成功！')
          setTimeout(() => {
            window.location.href = '#/localMerchant/liteApp/authorize'
          }, 3000)
        } else {
          return message.success('操作失败！')
        }
      }
    }
  }

  @action
  pay = () => {
    window.location.href =
      '#/localMerchant/cashier?payType=2&price=1299&title=开通小程序&return_url=/localMerchant/liteApp/authorize&&apiName=/p/wedding/Admin/APIMerchantWeapp/pay&checkApi=/p/wedding/Admin/APIMerchantWeapp&checkParams={"status":"1"}'
  }

  @observable server_end
  @observable register_status
  @action
  doCheck = async () => {
    let { data, success } = await checkApi.checkBind()
    if (success) {
      this.server_end = data.server_end
      this.register_status = data.register_status
    }
  }

  @observable loading = false
  @action
  replaceHash = async () => {
    this.loading = true
    const { data: shopInfo } = await homeApi.shopInfo()
    let { merchant_weapp } = shopInfo
    if (merchant_weapp == null) {
      return { auth_status: '', status: '', type: '' }
    }
    const { auth_status = '', status = '', type = '' } = merchant_weapp || {}
    // let {
    //   shopInfo: {
    //     merchant_weapp: { auth_status = '', status = '', type = '' }
    //   }
    // } = mainStore
    this.loading = false
    return { auth_status, status, type }
  }
}
export default new Store()
